export class Queue<T extends (args: unknown[]) => Promise<void>> {
  private queue: Array<T> = []
  private isRunning: boolean = false

  constructor(tasks: Array<T> = []) {
    this.queue = tasks
  }

  public async exec(): Promise<void> {
    if (this.isRunning) {
      return
    }

    this.isRunning = true

    while (this.queue.length > 0) {
      const task = this.queue.shift()
      if (task) {
        try {
          await task([])
        } catch (error) {
          console.error('Task execution failed:', error)
        }
      }
    }

    this.isRunning = false
  }

  public push(task: T): void {
    this.queue.push(task)

    if (!this.isRunning) {
      this.exec().catch((error) =>
        console.error('Error during execution:', error)
      )
    }
  }
}
